import React from "react";

export const AgoraContext = React.createContext({});
